import * as React from 'react';
import Sidebar from './components/layout/Sidebar';
import PricelistContent from './components/layout/PricelistContent';
import './Page.css';

const SIDEBAR_MIN_WIDTH = 200;
const SIDEBAR_MAX_WIDTH = 400;
const SIDEBAR_DEFAULT_WIDTH = 225;
const SIDEBAR_CLOSED_WIDTH = 24;

export const Page: React.FC = () => {
    const [isSidebarOpen, setIsSidebarOpen] = React.useState(true);
    const [sidebarWidth, setSidebarWidth] = React.useState(SIDEBAR_DEFAULT_WIDTH);
    const [isResizing, setIsResizing] = React.useState(false);

    const toggleSidebar = React.useCallback(() => {
        setIsSidebarOpen((v) => !v);
    }, []);

    const closeSidebar = React.useCallback(() => {
        setIsSidebarOpen(false);
    }, []);

    const handleResizeStart = React.useCallback((e: React.MouseEvent) => {
        if (e.button !== 0) return;
        e.preventDefault();
        setIsResizing(true);
    }, []);

    React.useEffect(() => {
        if (!isResizing) return;
        const onMove = (e: MouseEvent) => {
            const next = Math.max(SIDEBAR_MIN_WIDTH, Math.min(SIDEBAR_MAX_WIDTH, e.clientX));
            setSidebarWidth(next);
        };
        const onUp = () => setIsResizing(false);
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        return () => {
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            document.removeEventListener('mousemove', onMove);
            document.removeEventListener('mouseup', onUp);
        };
    }, [isResizing]);

    return (
        <div
            id="pricelist-page"
            className={`page ${isSidebarOpen ? 'reduced' : ''}`}
            style={isSidebarOpen ? { '--page-left': `${sidebarWidth}px` } as React.CSSProperties : undefined}
        >
            <Sidebar isOpen={isSidebarOpen} onToggle={toggleSidebar} width={sidebarWidth} />
            {isSidebarOpen && (
                <div
                    className="sidebar-resize-handle"
                    style={{ left: sidebarWidth - 3 }}
                    onMouseDown={handleResizeStart}
                />
            )}
            <PricelistContent
                isSidebarOpen={isSidebarOpen}
                onRequestCloseSidebar={closeSidebar}
            />
        </div>
    );
};
